export const HamburgerEventFeature = {
    GENERAL_NAVIGATION: 'general_navigation',
    CROSS_LINKS: 'cross_links',
};
//# sourceMappingURL=HamburgerMenu.types.js.map